export function max(numbers: number[]): number {
  return Math.max(...numbers);
}

export function min(numbers: number[]) {
  return Math.min(...numbers);
}

export function getNumberRange(minValue: number, maxValue: number) {
  const nums: number[] = [];
  for (let i = minValue; i <= maxValue; i++) {
    nums.push(i);
  }
  return Object.freeze(nums);
}

export function filterNullOrUndefined<T>(
  values: (T | null | undefined)[],
): T[] {
  return values.filter((x): x is T => x != null);
}
